<template>
    <div v-if="!userFullName" class="d-md-none d-print-none bg-white pt-4">

        <div class="header ml-4 mr-4">
            <img src="@/assets/images/logo.png" alt height="50" class="mb-3" />
            <div class="nayzak-everyone-in"> DigiTable est une solution tout-en-un pour gérer vos menus, commandes, paiements et fidélisation de manière simple et efficace. </div>
        </div>


        <div class="m-4">
            <div class="elementsdropdown-mobile" @click="showFooterQuickaccess = !showFooterQuickaccess; showFooterInfo = false, showFooterPubAg = false;">
                <div class="titleicon ">
                    <div class="product text-dark">Accès rapide</div>
                </div>
                <img class="iconchevron-down" alt="" src="@/assets/images/chevron-down.png" />
            </div>

            <!-- Shop links -->
            <div v-if="showFooterQuickaccess" >
                <FooterQuickaccess/>
            </div>

            <div class="elementsdropdown-mobile" @click="showFooterInfo = !showFooterInfo; showFooterQuickaccess = false, showFooterPubAg = false;">
                <div class="titleicon">
                    <div class="product text-dark">Informations</div>
                </div>
                <img class="iconchevron-down" alt="" src="@/assets/images/chevron-down.png" />
            </div>

            <!-- Informations links -->
            <div v-if="showFooterInfo" >
                <footerinfo/>
            </div>

            <div class="elementsdropdown-mobile " @click="showFooterPubAg = !showFooterPubAg; showFooterInfo = false, showFooterQuickaccess = false;">
                <div class="titleicon">
                    <div class="product text-dark">DigiTable</div>
                </div>
                <img class="iconchevron-down" alt="" src="@/assets/images/chevron-down.png" />
            </div>

            <!-- HA links -->
            <div v-if="showFooterPubAg" >
                <FooterPubAg/>
            </div>
        </div>


        <div class="container mb-3">
            <footerregion/>
            <!-- <img class="mr-1" alt="" src="@/assets/images/tunisia-flag.svg" />
            <div class="">Français</div>
            <img class="mr-1" alt="" src="@/assets/images/chevron-down.png" />
            <strong>
                <div style="text-decoration: underline;"></div>
            </strong>
            <img alt="" src="@/assets/images/arrow-right.svg" /> -->
        </div>

        <div class="container pt-2 mb-3">
            <footersocial/>
        </div>

        <div class="container pb-0">
            <span class="nayzak">© {{ new Date().getFullYear() }} DigiTable Copyright</span>
        </div>

        <div class="container pb-3">
            <a href="/" class="text-info mt-2" style="color:#92B9B1" target="_blank">Digitable</a>
        </div>


    </div>
</template>

<script>

import FooterQuickaccess from "@/components/footer-quick-access.vue"
import footerinfo from "@/components/footer-info.vue"
import FooterPubAg from "@/components/footer-pubAg.vue"
import footersocial from "@/components/footer-social.vue"
import footerregion from "@/components/footer-region.vue"


export default ({
    name: "MobileFooter",

    components: {
        FooterQuickaccess, footerinfo, FooterPubAg, footersocial, footerregion
    },

    computed: {
        userFullName() {
        return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
        },

    },

    data() {
        return {
            showFooterQuickaccess: false,
            showFooterInfo: false,
            showFooterPubAg: false,
        }
    },
})



</script>

<style scoped>
.product {
    flex: 1;
    position: relative;
    line-height: 24px;
    font-weight: 500;
}

.titleicon {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.iconchevron-down {
    position: relative;
    width: 20px;
    height: 20px;
}

.elementsdropdown-mobile {
    width: 100%;
    position: relative;
    border-bottom: 1px solid #cbcbcb;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0px;
    gap: 24px;
    text-align: left;
    font-size: 14px;
    color: #3e3e59;
    font-family: 'Space Grotesk';
}

.calque-1-icon {
    position: relative;
    width: 30px;
    height: 26.03px;
    overflow: hidden;
    flex-shrink: 0;
}

.nayzak-everyone-in {
    align-self: stretch;
    position: relative;
    line-height: 22px;
}

.header {
    /*width: 100%;*/
    /*position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;*/
    gap: 16px;
    text-align: justfiy;
    font-size: 14px;
    color: #3e3e59;
    font-family: Inter;
}


.container {
    display: flex;
    justify-content: center;
    align-items: center;

}

.icon {
    margin-right: 5px;
}

.icon:last-child {
    margin-right: 0;
}

.nayzak {
    position: relative;
    font-size: 12px;
    line-height: 20px;
    font-family: Inter;
    color: #3e3e59;
    text-align: center;
}
</style>
